import axios from 'axios';
import moment from 'moment-timezone';

import api from './api';
import libs from './libs/index';

moment.tz.setDefault('Asia/Taipei');
export default {
  axios,
  moment,
  api,
  ...libs,
};
